// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">

    <customer-credit-line-details
      credit-line="\$ctrl.creditLine"
      form="\$ctrl.creditLineForm"
      ng-if="\$ctrl.creditLine"
    >
    </customer-credit-line-details>

    <div class="clearfix"></div>

    <div class="flex-end">
      <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
      <button class="btn btn-primary" ng-click="\$ctrl.updateCreditLine()" ng-disabled="\$ctrl.creditLineForm.\$invalid">Update</button>
    </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/credit-line/edit/customer-credit-line-edit.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;